import React, { useState } from 'react';
import { View, Switch, Text } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import moment from 'moment';
import styled from 'styled-components/native';
import { DateTime } from 'luxon';

import DataState from 'app/src/components/DataState';
import minimalTable from 'app/src/elements/minimalTable';
import { useParams } from 'app/src/utils/routing';

import { SALE_BIDDING_EVENTS } from './queries';
import { Title, Field, Label } from '../elements';

const Toggles = styled(View)`
  flex-direction: row;
  gap: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Events = () => {
  const { id } = useParams();
  const [levels, setLevels] = useState(['Auction', 'Messages']);

  const { data } = useQuery( SALE_BIDDING_EVENTS, { variables: { id } });

  if (!data) { return <DataState.Loading />; }

  let events = data.sale.biddingEvents.filter(biddingEvent => (
    levels.includes(biddingEvent.level)
  ));

  if (levels.includes('Streams')) {
    const streamEvents = data.sale.videoStreams.map(stream => (
      {
        createdAt: stream.startAt,
        level: 'Streams',
        action: 'Audio Stream',
        video: stream.video,
      }
    ));

    events = [...events, ...streamEvents];
  }

  const toggleLevel = level => {
    if (levels.includes(level)) {
      setLevels([...levels.filter(item => item !== level)]);
    } else {
      setLevels([...levels, level]);
    }
  }

  const columns = [
    {
      key: 'createdAt',
      label: 'Time',
      sort: 'asc',
      width: 200,
      content: ({ value }) => (
        moment(value).format('ddd, M/D @ h:mm:ss A')
      ),
    },
    {
      key: 'action',
      label: 'Action',
      sort: 'prevent',
      width: 300,
    },
    {
      key: 'displayValue',
      label: 'Value',
      sort: 'prevent',
      width: 400,
      cellStyle: {
        paddingVertical: 0,
        paddingHorizontal: 0,
      },
      content: ({ entry, value }) => (
        'Streams' === entry.level ? (
          entry.video ? (
            <audio
              controls
              src={entry.video.url}
              style={{ height: 30 }}
            />
          ) : (
            <Text>Recording not available</Text>
          )
        ) : (
          <View style={{ padding: 8, backgroundColor: entry.backgroundColor }}>
            <Text style={{ color: entry.foregroundColor, fontWeight: 600 }}>
              {value}
            </Text>
          </View>
        )
      )
    },
    {
      key: 'saleAssetName',
      label: 'Asset',
      sort: 'prevent',
    },
    {
      key: 'bidderDescription',
      label: 'Bidder',
      sort: 'prevent',
      width: 300,
    },
  ];

  if (levels.includes('Streams') || true) {
    columns.push({
      key: 'recording',
      label: 'Audio',
      sort: 'prevent',
      content: ({ entry }) => {
        if ('Bid' === entry.action) { return ''; }

        const recording = data.sale.saleRecordings.find(possible => (
          possible.startAt < entry.createdAt &&
            possible.endAt > entry.createdAt
        ));

        if (!recording) { return ''; }
        console.log(recording.startAt);
        console.log(entry.createdAt);

        const diff = DateTime.fromISO(entry.createdAt).diff(
          DateTime.fromISO(recording.startAt),
          'seconds'
        ).toObject();

        return (
          <audio
            controls
            src={
              `${recording.url}#t=${diff.seconds}`
            }
            style={{ height: 30 }}
          />
        );
      }
    });
  }


  return (
    <View style={{margin: 20}}>
      <Title>{data.sale.name}</Title>

      <Toggles>
        <Field>
          <Label>Display Auction Level Events</Label>
          <Switch
            value={levels.includes('Auction')}
            onValueChange={() => toggleLevel('Auction')}
          />
        </Field>
        <Field>
          <Label>Display Message Changes</Label>
          <Switch
            value={levels.includes('Messages')}
            onValueChange={() => toggleLevel('Messages')}
          />
        </Field>
        <Field>
          <Label>Display Asset Level Events</Label>
          <Switch
            value={levels.includes('Asset')}
            onValueChange={() => toggleLevel('Asset')}
          />
        </Field>
        <Field>
          <Label>Audio Streams</Label>
          <Switch
            value={levels.includes('Streams')}
            onValueChange={() => toggleLevel('Streams')}
          />
        </Field>
      </Toggles>

      <DataTable.Simple
        data={events}
        columns={columns}
        component={minimalTable}
        pageLength="All"
        htmlTable
      />
    </View>
  );
};

export default Events;
